import React from 'react';
import markdownContent from '!!raw-loader!static/health_requirements.md';
import { Markdown } from 'Common';

export const HealthPage = () => {
  return <Markdown>{markdownContent}</Markdown>;
};

export default HealthPage;
